import React from 'react';
import "../../../assets/css/provacyterms.css"


export default class XiaohePrivacy extends React.Component {
    componentDidMount() {
      document.title = "Privacy"
    }
  
  render() {
    return (
      <html lang="en">
      <head>
      <meta charset="utf-8" />
      <meta http-equiv="X-UA-Compatible" content="IE=edge,chrome=1" />
      <title>Privacy Policy</title>
      <meta name="robots" content="noindex" />
      <link rel="apple-touch-icon-precomposed" sizes="57x57" href="/assets/images/apple-touch-icon-57x57.png" />
      <link rel="apple-touch-icon-precomposed" sizes="114x114" href="/assets/images/apple-touch-icon-114x114.png" />
      <link rel="apple-touch-icon-precomposed" sizes="72x72" href="/assets/images/apple-touch-icon-72x72.png" />
      <link rel="apple-touch-icon-precomposed" sizes="144x144" href="/assets/images/apple-touch-icon-144x144.png" />
      <link rel="apple-touch-icon-precomposed" sizes="60x60" href="/assets/images/apple-touch-icon-60x60.png" />
      <link rel="apple-touch-icon-precomposed" sizes="120x120" href="/assets/images/apple-touch-icon-120x120.png" />
      <link rel="apple-touch-icon-precomposed" sizes="76x76" href="/assets/images/apple-touch-icon-76x76.png" />
      <link rel="apple-touch-icon-precomposed" sizes="152x152" href="/assets/images/apple-touch-icon-152x152.png" />
      <link rel="icon" type="image/png" href="/assets/images/favicon-196x196.png" sizes="196x196" />
      <link rel="icon" type="image/png" href="/assets/images/favicon-96x96.png" sizes="96x96" />
      <link rel="icon" type="image/png" href="/assets/images/favicon-32x32.png" sizes="32x32" />
      <link rel="icon" type="image/png" href="/assets/images/favicon-16x16.png" sizes="16x16" />
      <link rel="icon" type="image/png" href="/assets/images/favicon-128x128.png" sizes="128x128" />
      <meta name="application-name" content="&nbsp;" />
      <meta name="msapplication-TileColor" content="#FFFFFF" />
      <meta name="msapplication-TileImage" content="/assets/images/mstile-144x144.png" />
      <meta name="msapplication-square70x70logo" content="/assets/images/mstile-70x70.png" />
      <meta name="msapplication-square150x150logo" content="/assets/images/mstile-150x150.png" />
      <meta name="msapplication-wide310x150logo" content="/assets/images/mstile-310x150.png" />
      <meta name="msapplication-square310x310logo" content="/assets/images/mstile-310x310.png" />
      
      <link href="/assets/css/live.css" rel="stylesheet" />
      </head>
      <body>
      <div class="wrapper py-5">
      <div class="page">
      <section class="sect-live">
      <div class="container">
      <div class="row">
      <div class="col-md-12">
      <h1>Privacy Policy for Xiao He</h1>
      <p>At Xiao He, one of our main priorities is the privacy of our visitors. This Privacy Policy document contains types of information that is collected and recorded by Xiao He and how we use it.</p>
      <p>If you have additional questions or require more information about our Privacy Policy, do not hesitate to contact us.</p>
      <h2>Log Files</h2>
      <p> Xiao He follows a standard procedure of using log files. These files log visitors when they use app. The information collected by log files include internet protocol (IP) addresses, browser type, Internet Service Provider (ISP), date and time stamp, referring/exit pages, and possibly the number of clicks. These are not linked to any information that is personally identifiable. The purpose of the information is for analyzing trends, administering the app, tracking users' movement on the app, and gathering demographic information.</p>
      <h2>Our Advertising Partners</h2>
      <p>Some of advertisers in our app may use cookies and web beacons. Our advertising partners are listed below. Each of our advertising partners has their own Privacy Policy for their policies on user data. For easier access, we hyperlinked to their Privacy Policies below.</p>
      <ul>
      <li>
      <p>Google</p>
      <p><a href="https://policies.google.com/technologies/ads">https://policies.google.com/technologies/ads</a></p>
      </li>
      </ul>
      <h2>Privacy Policies</h2>
      <p>You may consult this list to find the Privacy Policy for each of the advertising partners of Xiao He.</p>
      <p>Third-party ad servers or ad networks uses technologies like cookies, JavaScript, or Beacons that are used in their respective advertisements and links that appear on Xiao He. They automatically receive your IP address when this occurs. These technologies are used to measure the effectiveness of their advertising campaigns and/or to personalize the advertising content that you see on this app or other apps or websites.</p>
      <p>Note that Xiao He has no access to or control over these cookies that are used by third-party advertisers.</p>
      <h2>Third Party Privacy Policies</h2>
      <p> Xiao He's Privacy Policy does not apply to other advertisers or websites. Thus, we are advising you to consult the respective Privacy Policies of these third-party ad servers for more detailed information. It may include their practices and instructions about how to opt-out of certain options.</p>
      <h2>Children's Information</h2>
      <p>Another part of our priority is adding protection for children while using the internet. We encourage parents and guardians to observe, participate in, and/or monitor and guide their online activity.</p>
      <p> Xiao He does not knowingly collect any Personal Identifiable Information from children under the age of 13. If you think that your child provided this kind of information on our App, we strongly encourage you to contact us immediately and we will do our best efforts to promptly remove such information from our records.</p>
      <h2>Online Privacy Policy Only</h2>
      <p>This Privacy Policy applies only to our online activities and is valid for visitors to our App with regards to the information that they shared and/or collect in Xiao He. This policy is not applicable to any information collected offline or via channels other than this app. Our Privacy Policy was created with the help of the <a href="https://www.app-privacy-policy.com/app-privacy-policy-generator/">App Privacy Policy Generator from App-Privacy-Policy.com</a></p>
      <h2>Consent</h2>
      <p>By using our app, you hereby consent to our Privacy Policy and agree to its Terms and Conditions.</p>
      <hr />
      <p>Generated using <a href="https://www.app-privacy-policy.com">App Privacy Policy Generator</a></p>
      </div>
      </div>
      </div>
      </section>
      </div>
      </div>
      </body>
      </html>);
  }
  
    
  }
  